import { createAsyncThunk } from '@reduxjs/toolkit'

import { getAllLinks } from '../../services/links'

export const getLinks = createAsyncThunk(`auth/links`, async () => {
  const res = getAllLinks()
  return res
})
